<input type="text" *ngIf="!showMap" class="w-full text-sm" [formControl]="competitorName" pInputText
    [placeholder]="placeHolderName" autocorrect="off" autocapitalize="off" spellcheck="off"
    (keydown.enter)="$event.preventDefault()" #search>

<div #map *ngIf="showMap" style="height: 300px; width: 100%;"></div>